import { render } from "./portrait_guanyin.vue?vue&type=template&id=d20f7db4&scoped=true"
import script from "./portrait_guanyin.vue?vue&type=script&lang=js"
export * from "./portrait_guanyin.vue?vue&type=script&lang=js"

import "./portrait_guanyin.vue?vue&type=style&index=0&id=d20f7db4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20f7db4"]])

export default __exports__